<template>
<div>
  <v-layout wrap>
    <v-flex xs12 sm6 md12>
      <v-form @submit.prevent="pesquisar()" ref="form">
        <v-layout align-center wrap fill-height> 
          <v-flex xs12 sm6 md4>
            <v-select v-model="objetivo.idFaixaAno" item-text="nomeCombo" item-value="id"
              :items="faixasAnos" label="Faixa/Ano"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Código" v-model="objetivo.codigo"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md1>
            <check-box-state label="BNCC" @checkBoxStateAtualizado="objetivo.bncc = $event"/>
          </v-flex>
          <v-flex xs12 sm6 md1>
            <check-box-state label="Ativo" @checkBoxStateAtualizado="objetivo.ativo = $event"/>
          </v-flex>
          <v-flex xs12 sm6 md1>
            <v-btn color="primary" alt="Limpar" title="Limpar" @click="limpar()"> <v-icon>clear</v-icon></v-btn>
          </v-flex>
          <v-flex xs12 sm6 md1>
            <v-btn color="primary" alt="Pesquisar" title="Pesquisar" type="submit"> <v-icon>find_in_page</v-icon></v-btn>
          </v-flex>
          <v-flex xs12 sm2 md2>
            <modal-cadastro-objetivo :faixas-anos="faixasAnos" @objetivoCadastrado="cadastroEfetuado = $event" />
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
    <v-flex xs12 sm2 md12>
      <v-data-table :loading="loading" :headers="headers" :items="objetivos" class="elevation-1" :total-items="pagination.totalItems" :pagination.sync="pagination">
        <template slot="items" slot-scope="props">
          <td width="15%">{{ props.item.faixaAno }}</td>
          <td>{{ props.item.bncc | booleanFilter }}</td>
          <td>{{ props.item.codigo }}</td>
          <td>{{ props.item.camposExperiencia }}</td>
          <td width="30%">{{ props.item.descricao }}</td>
          <td>{{ props.item.ativo | booleanFilter }}</td>
          <td>
            <v-icon title="Editar" medium class="mr-2" @click="editar(props.item)">
              edit
            </v-icon>
            <v-icon title="Excluir" medium class="mr-2" @click="excluir(props.item)" >
              delete
            </v-icon>
          </td>
        </template>
        <template slot="no-data">
          Não existem informações cadastradas!
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</div>
</template>
<script>
import baseCurricularService from "@/service/basecurricular/BaseCurricularService";
import Objetivo from "@/model/basecurricular/Objetivo";
import ModalCadastroObjetivo from "./ModalCadastroObjetivo";
import Pagination from "@/utils/Pagination.js";
import EventBus from "@/utils/EventBus";
import { booleanFilter } from "@/filters/Filters.js";
import CheckBoxState from "@/components/Custom/CheckBoxState";

export default {
  name: "ListaObjetivo",
  components: {
    ModalCadastroObjetivo,
    CheckBoxState
  },
  filters: {
    booleanFilter: booleanFilter
  },
  data() {
    return {
      dialog: false,
      idFaixaAno: null,
      faixasAnos: [],
      objetivos: [],
      pagination: new Pagination(1, 5),
      loading: true,
      cadastroEfetuado: false,
      objetivo: new Objetivo(),
      headers: [
        {
          text: "Faixa/Ano",
          align: "left",
          sortable: false,
          value: "faixaAno"
        },
        {
          text: "BNCC",
          align: "left",
          sortable: false,
          value: "bncc"
        },
        {
          text: "Código",
          align: "left",
          sortable: false,
          value: "codigo"
        },
        {
          text: "Campo Experiência",
          align: "left",
          sortable: false,
          value: "camposExperiencia"
        },
        {
          text: "Descrição",
          align: "left",
          sortable: false,
          value: "descricao"
        },
        {
          text: "Ativo",
          align: "left",
          sortable: false,
          value: "ativo"
        },
        { text: "", value: "name", sortable: false }
      ]
    };
  },
  watch: {
    cadastroEfetuado(event) {
      if (event) {
        setTimeout(() => {
          this.pesquisar();
          this.cadastroEfetuado = false;
        }, 500);
      }
    },
    idFaixaAno() {
      this.pesquisar();
    },
    pagination: {
      handler() {
        this.pesquisar();
      }
    }
  },
  created() {
    this.carregarDadosBasicos();
  },
  methods: {
    limpar() {
      this.objetivo = new Objetivo();
      EventBus.$emit("resetCheckBoxState");
      this.pesquisar();
    },
    excluir(objetivo) {
      confirm("Você deseja realmente excluir Objetivo?") &&
        baseCurricularService.excluirObjetivo(objetivo).then(() => {
          this.objetivos.splice(
            this.objetivos.indexOf(objetivo),
            1
          );
          this.atualizar();
        });
    },
    editar(objetivo) {
      EventBus.$emit("editaObjetivo", objetivo.id);
    },
    atualizar() {
      this.pesquisar();
    },
    async carregarDadosBasicos() {
      this.faixasAnos = await baseCurricularService.faixasAnos();
    },
    async pesquisar() {
      this.loading = true;
      if (this.objetivo.codigo === "") {
        this.objetivo.codigo = null;
      }
      const paginacaoResultado = await baseCurricularService.listarTodosObjetivos(
        this.objetivo,
        this.pagination.page,
        this.pagination.rowsPerPage
      );
      this.objetivos = paginacaoResultado.dados;
      this.pagination.totalItems = paginacaoResultado.total;
      this.loading = false;
    }
  }
};
</script>
